import TableSimpleCell from "ds/components/TableSimple/Cell";

import { IntegrationsAzureUsedByTableCellProps } from "./types";

const IntegrationsAzureUsedByTableDropdownCell = ({
  ...cellProps
}: IntegrationsAzureUsedByTableCellProps) => {
  return <TableSimpleCell {...cellProps} />;
};

export default IntegrationsAzureUsedByTableDropdownCell;
